import { render, staticRenderFns } from "./transferMerchantConfig.vue?vue&type=template&id=2f5cb078&"
import script from "./transferMerchantConfig.vue?vue&type=script&lang=js&"
export * from "./transferMerchantConfig.vue?vue&type=script&lang=js&"
import style0 from "./transferMerchantConfig.vue?vue&type=style&index=0&id=2f5cb078&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports